<template>
  <div class="business-content-main">
    <div class="bread-nav">
      <breadcrumb></breadcrumb>
    </div>
    <el-container style="height:650px;">
      <el-header style="padding:0px;margin:0px;">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="新建申请" name="addApply">
            <el-container style="height:100%">
              <el-main width="80%" style="height:100%; padding:0px;margin:0px;">
                <el-card class="box-card" style="padding:15px;height:100%;overflow:auto;">
                  <el-form
                    :rules="rules"
                    style="width:550px"
                    :model="editApplyRecordData"
                    ref="editApplyRecordData"
                    label-width="120px"
                  >
                    <el-form-item label="审批类型:" prop="typeId">
                      <el-select
                        style="width:100%;"
                        v-model="editApplyRecordData.typeId"
                        filterable
                        clearable
                        @change="onTypeChange"
                        @clear="onClear"
                      >
                        <el-option
                          v-for="item in applyTypeSelect"
                          :key="item.Id"
                          :label="item.Name"
                          :value="item.Id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="审批人员:" prop="approverSelectList">
                      <el-select
                        style="width:100%;"
                        multiple
                        v-model="approverSelectList"
                        placeholder="您还没有相对应的审批流程"
                        :disabled="true"
                      >
                        <el-option
                          v-for="item in approverList"
                          :key="item.Id"
                          :label="item.Name"
                          :value="item.Id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="通知人员:" prop="notifierSelectList">
                      <el-select
                        style="width:100%;"
                        multiple
                        v-model="notifierSelectList"
                        placeholder="暂无设置通知人"
                        :disabled="true"
                      >
                        <el-option
                          v-for="item in notifierList"
                          :key="item.Id"
                          :label="item.Name"
                          :value="item.Id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="请假时间:" prop="datetime">
                      <el-date-picker
                        style="width:100%;"
                        v-model="editApplyRecordData.datetime"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        @change="onDateTimeSelect"
                      ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="请假原因:" prop="reason">
                      <el-input
                        type="textarea"
                        :rows="5"
                        placeholder="请输入内容"
                        v-model="editApplyRecordData.reason"
                      ></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-upload
                        :action="singleUploadUrl"
                        :headers="headerObj"
                        :on-remove="handleRemove"
                        :before-remove="beforeRemove"
                        :on-success="onUploadSuccess"
                        :on-error="onUploadError"
                        multiple
                        :file-list="fileList"
                      >
                        <el-button size="medium" type="text">
                          <i class="el-icon-upload"></i>添加附件
                        </el-button>
                        <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                      </el-upload>
                    </el-form-item>
                    <el-form-item>
                      <el-button size="small" class="btn-primary" @click="submitApproval">提交</el-button>
                    </el-form-item>
                  </el-form>
                </el-card>
              </el-main>
            </el-container>
          </el-tab-pane>
          <!-- <el-tab-pane label="批量登记" name="addApplyForStaffs" v-if="false">
            <el-container style="height:100%">
              <el-aside width="20%" height="100%" style="margin-right:20px;">
                <el-card class="box-card" style="padding:25px;height:600px;overflow:auto;">
                  <el-input placeholder="搜索姓名" suffix-icon="el-icon-search" v-model="selName"></el-input>
                  <el-tree
                    ref="tree"
                    :data="orgTreeWithStaff"
                    show-checkbox
                    :render-after-expand="false"
                    node-key="Id"
                    :props="treeProps"
                    :default-expanded-keys="defaultexpanded"
                    :filter-node-method="filterNode"
                    @check-change="onCheckchange"
                  >
                    <span slot-scope="{ node, data }">
                      <span>{{ node.label }} {{data.Type=="org"?'('+data.StaffCount+')':""}}</span>
                    </span>
                  </el-tree>
                </el-card>
              </el-aside>
              <el-main width="80%" style="height:100%; padding:0px;margin:0px;">
                <el-card class="box-card" style="padding:15px;height:100%;overflow:auto;">
                  <el-form
                    style="width:550px"
                    :model="editApplyRecordData"
                    :rules="rules"
                    ref="editApplyRecordData"
                    label-width="120px"
                  >
                    <el-form-item label="审批类型:" prop="typeId">
                      <el-select
                        style="margin-right:10px"
                        v-model="editApplyRecordData.typeId"
                        filterable
                        clearable
                        @change="onTypeChange"
                      >
                        <el-option
                          v-for="item in entpStaffsList"
                          :key="item.Id"
                          :label="item.Name"
                          :value="item.Id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="登记对象:" prop="typeId">
                      <el-select
                        style="width:100%"
                        v-model="signStaffList"
                        filterable
                        multiple
                        @change="onSignStaffChange"
                        @remove-tag="removeSignStaff"
                      >
                        <el-option
                          v-for="item in entpStaffsList"
                          :key="item.Id"
                          :label="item.Name"
                          :value="item.Id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="请假时间:" prop="typeId">
                      <el-date-picker
                        v-model="addApplyStfDateTime"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                      ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="请假原因:" prop="typeId">
                      <el-input
                        type="textarea"
                        :rows="5"
                        placeholder="请输入内容"
                        v-model="editApplyRecordData.reason"
                      ></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button size="small" class="btn-primary">提交</el-button>
                    </el-form-item>
                  </el-form>
                </el-card>
              </el-main>
            </el-container>
          </el-tab-pane>-->
        </el-tabs>
      </el-header>
    </el-container>
  </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
export default {
  name: "addApply",
  components: {
    breadcrumb
  },
  data() {
    let userMsg=this.$util.getLocalStorage("userMsg");
    return {
      recordDetail: {},
      activeName: "addApply",
      detailId: "",
      entpId: userMsg.EntpId,
      permission: {},
      singleUploadUrl: "/api/UploadFile/UploadSingle",
      headerObj: {
            'access-key': userMsg.Token,
            reqApp: 'yqgPC'
      },        
      editApplyRecordData: {
        id: "",
        entpId:userMsg.EntpId,
        staffId: userMsg.EmployeeId,
        typeId: "",
        typeName: "",
        startTime: "",
        endTime: "",
        reason: "",
        annexs: [
          {
            url: "",
            name: ""
          }
        ],
        datetime: []
      },
      applyCheckFlowSearchData: {
        entpId:userMsg.EntpId,
        typeId: "",
        name: "",
        orgId: "",
        staffIds: "",
        page: 1,
        limit: 1000
      },
      entpStaffsSearchData: {
        entpId: userMsg.EntpId,
        cascadeId: "",
        name: ""
      },
      flowObjsSearchData: {
        entpId: userMsg.EntpId,
        flowId:userMsg.EntpId,
        objType: 1
      },
      entpApplyTypesSearchData: {
        entpId:userMsg.EntpId,
        name: "",
        page: 1,
        limit: 1000
      },
      staffApplyFlowByTypeId: {
        applyTypeId: "",
        staffId: userMsg.EmployeeId
      },
      fileList: [],
      approverSelectList: [],
      notifierSelectList: [],
      approverList: [], //审批人列表
      notifierList: [], //通知人列表
      staffApplyFlowList: [],
      entpApplyCheckFlowList: [],
      entpStaffsList: [], //企业员工列表
      applyTypeSelect: [],
      flowObjs: [],
      orgTreeWithStaff: [],
      defaultexpanded: [],
      signStaffList: [],
      addApplyStfDateTime: [],
      filterNode(value, data) {
        if (!value) return true;
        return data.Name.indexOf(value) !== -1;
      },
      treeProps: {
        children: "Childrens",
        label: "Name",
        value: "Id",
        multiple: true,
        emitPath: false
      },
      rules: {
        typeId: [
          { required: true, message: "请选申请类型", trigger: "change" }
        ],
        datetime: [
          {
            required: true,
            message: "请选择日期时间",
            trigger: "change"
          }
        ],
        reason: [{ required: true, message: "请输入理由", trigger: "blur" }]
      }
    };
  },
  created() {
    this.getApplyTypeSelectList();
    // this.getOrgTreeWithStaff();
    // this.getEntpStaffsSelectList();
  },
  mounted() {
    let id = this.$route.query.id;
    if (id) {
      this.detailId = id;
      this.editApplyRecordData.id = id;
      this.getApplyRecordDetail();
    }
  },
  methods: {
    onUploadSuccess(response, file, fileList) {
      if (response.errcode == 0) {
        // this.editShareInventoryData.mainImg = response.fileUrl;
        this.editApplyRecordData.annexs.push({
          url: response.fileUrl,
          name: response.fileName
        });
      }
    },
    onUploadError(msg) {
      this.$util.warningMsg("上传附件失败");
    },
    handleExceed(files, fileList) {
      // this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    handleRemove(file, fileList) {
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    submitApproval() {
      this.$refs["editApplyRecordData"].validate(valid => {
        if (valid) {
          this.editApplyRecord();
        } else {
          return false;
        }
      });
    },
    onClear() {
      this.approverSelectList = [];
      this.notifierSelectList = [];
    },
    //找已选中的员工
    duplicateCheckForOrgTree(val) {
      if (val.length > 0) {
        let result = [];
        for (let i = 0; i < val.length; i++) {
          let vId = val[i].Id;
          for (let j = 0; j < this.entpStaffsList.length; j++) {
            let staffId = this.entpStaffsList[j].Id;
            if (vId == staffId) {
              result.push(vId);
            }
          }
        }
        return result;
      }
    },
    onCheckchange(data, checked, indeterminate) {
      if (checked) {
        if (data.Type == "staff") {
          let checkedNodes = this.$refs.tree.getCheckedNodes(true, false);
          this.signStaffList = this.duplicateCheckForOrgTree(checkedNodes);
        }
      } else if (!checked && !indeterminate) {
        if (data.Type == "staff") {
          for (let index = 0; index < this.signStaffList.length; index++) {
            let element = this.signStaffList[index];
            if (element == data.Id) {
              this.signStaffList.splice(index, 1);
            }
          }
        }
      }
    },
    //批量申请 勾选组织列表
    onSignStaffChange(val) {
      val.forEach(element => {
        this.$refs.tree.setChecked(element, true, true);
      });
    },
    //批量申请 取消勾选组织列表
    removeSignStaff(Id) {
      this.$refs.tree.setChecked(Id, false, true);
    },
    //选中类型
    onTypeChange(val) {
      this.staffApplyFlowByTypeId.applyTypeId = val;
      this.editApplyRecordData.typeId = val;
      let type = this.applyTypeSelect.find(item => {
        return item.Id == this.editApplyRecordData.typeId;
      });
      this.editApplyRecordData.typeName = type.Name;
      this.getStaffApplyFlowByTypeId();
    },
    //选中时间
    onDateTimeSelect(val) {
      if (val != null) {
        this.editApplyRecordData.startTime = val[0];
        this.editApplyRecordData.endTime = val[1];
      }else{
         this.editApplyRecordData.startTime = "";
        this.editApplyRecordData.endTime = "";       
      }
    },
    //新建/编辑申请
    editApplyRecord() {
      this.$util
        .axiosPost({
          url: "/api/AttendanceSystem/EditApplyRecord",
          data: this.editApplyRecordData
        })
        .then(res => {
          if (res.errcode == 0) {
            this.$util.successMsg("提交成功");
            this.$router.push({ path: "applyManage" });
          }
        })
        .catch(err => {});
    },
    //根据类型获取审核/通知人员列表
    getStaffApplyFlowByTypeId() {
      this.$util
        .axiosGet({
          url: "/api/AttendanceSystem/GetStaffApplyFlowByTypeId",
          data: this.staffApplyFlowByTypeId
        })
        .then(res => {
          this.dataCount = res.count;
          if (res.data) {
            this.staffApplyFlowList = res.data;
            this.approverListt = [];
            this.approverSelectList = [];
            this.notifierList = [];
            this.notifierSelectList = [];
            for (
              let index = 0;
              index < this.staffApplyFlowList.length;
              index++
            ) {
              let element = this.staffApplyFlowList[index];
              if (element.ObjType == "1") {
                this.approverList.push(element);
                this.approverSelectList.push(element.Id);
              } else if (element.ObjType == "2") {
                this.notifierList.push(element);
                this.notifierSelectList.push(element.Id);
              }
            }
          }
        })
        .catch(err => {});
    },
    //获取假期类型
    getApplyTypeSelectList() {
      this.$util
        .axiosGet({
          url: "/api/AttendanceSystem/GetApplyTypeSelectList",
          data: {
            entpId: this.entpId
          }
        })
        .then(res => {
          if (res.data) {
            this.applyTypeSelect = res.data;
          }
        })
        .catch(err => {});
    },
    //获取流程人员
    getFlowObjs() {
      this.$util
        .axiosGet({
          url: "/api/AttendanceSystem/GetFlowObjs",
          data: this.flowObjsSearchData
        })
        .then(res => {
          if (res.data) {
            this.flowObjs = res.data;
          }
        })
        .catch(err => {});
    },
    //获取组织结构和员工
    getOrgTreeWithStaff() {
      this.$util
        .axiosGet({
          url: "/api/AttendanceSystem/GetOrgTreeWithStaff",
          data: { entpId: this.entpId }
        })
        .then(res => {
          if (res.data) {
            if (res.data[0].Id == null) {
              res.data[0].Id = "1";
            }
            this.orgTreeWithStaff = res.data;
            this.defaultexpanded = [res.data[0].Id];
          }
        })
        .catch(err => {});
    },
    //获取企业员工
    getEntpStaffsSelectList() {
      this.$util
        .axiosGet({
          url: "/api/AttendanceSystem/GetEntpStaffsSelectList",
          data: this.entpStaffsSearchData
        })
        .then(res => {
          if (res.data) {
            this.entpStaffsList = res.data;
          }
        })
        .catch(err => {});
    },
    //获取流程列表
    GetEntpApplyCheckFlowsList() {
      this.$util
        .axiosGet({
          url: "/api/AttendanceSystem/GetEntpApplyCheckFlowsList",
          data: this.applyCheckFlowSearchData
        })
        .then(res => {
          if (res.data) {
            this.dataCount = res.count;
            this.entpApplyCheckFlowList = res.data;
          }
        })
        .catch(err => {});
    },
    getApplyRecordDetail() {
      this.$util
        .axiosGet({
          url:
            "/api/AttendanceSystem/GetApplyRecordDetail?applyId=" +
            this.detailId
        })
        .then(res => {
          if (res.data) {
            this.recordDetail = res.data;
            this.editApplyRecordData.typeId = this.recordDetail.TypeId;
            this.onTypeChange(this.editApplyRecordData.typeId);
            this.editApplyRecordData.datetime.push(this.recordDetail.StartTime);
            this.editApplyRecordData.datetime.push(this.recordDetail.EndTime);
            this.onDateTimeSelect(this.editApplyRecordData.datetime);
            this.editApplyRecordData.reason = this.recordDetail.Reason;
            if (this.recordDetail.Annexs.length > 0) {
              for (
                let index = 0;
                index < this.recordDetail.Annexs.length;
                index++
              ) {
                let element = this.recordDetail.Annexs[index];
                this.fileList.push({ url: element.Url, name: element.Name });
              }
            }
          }
        })
        .catch(err => {});
    }
  }
};
</script>
<style lang="less" scoped>
</style>
